<template>
  <div class="identity-verification">
    <!-- 详情头 -->
    <a-space align="center">
      <a-icon type="left" style="font-size: 23px" @click="changeToInfoDetail" />
      <div
        class="ant-descriptions-title"
        style="font-size: 16px; margin-bottom: 0px"
      >
        身份认证
      </div>
    </a-space>
    <!-- 详情头 -->
    <!-- 步骤条 -->
    <a-steps
      :current="currentStep"
      style="margin-bottom: 30px; margin-top: 20px"
    >
      <a-step title="居民身份证" />
      <a-step title="本人操作" />
      <a-step title="认证成功" />
    </a-steps>

    <!-- 主体内容 -->
    <div v-if="currentStep === 0">
      <div class="verification-content" style="margin-top: 40px">
        <div class="left-section">
          <!-- <a-row type="flex" justify="space-around" align="middle"> -->
          <!-- <a-col :span="12"> -->
          <div class="upload-item" style="height: 180px">
            <div class="upload-box">
              <a-icon type="plus-circle" class="upload-icon" />
              <span>请上传身份证正面</span>
            </div>

            <div class="clearfix">
              <a-upload
                action="https://api.jssyjt.net/external-service-center/baiduRecognize/idCard"
                :headers="uploadHeaders"
                list-type="picture-card"
                :file-list="idCardFront"
                @preview="handlePreview"
                @change="handleIdCardFrontChange"
                :multiple="false"
                :show-upload-list="true"
                accept=".jpg,.png"
                :data="{ idCardSide: 'front' }"
              >
                <div v-if="idCardFront.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">请上传图片</div>
                </div>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="previewHandleCancel"
              >
                <img alt="身份证正面" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </div>

          <div class="upload-item">
            <div class="upload-box">
              <a-icon type="plus-circle" class="upload-icon" />
              <span>请上传身份证反面</span>
            </div>
            <div class="clearfix">
              <a-upload
                action="https://api.jssyjt.net/external-service-center/baiduRecognize/idCard"
                :headers="uploadHeaders"
                list-type="picture-card"
                :file-list="idCardBack"
                @preview="handlePreview"
                @change="handleIdCardBackChange"
                :multiple="false"
                :show-upload-list="true"
                accept=".jpg,.png"
                :data="{ idCardSide: 'back' }"
              >
                <div v-if="idCardBack.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">请上传图片</div>
                </div>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="previewHandleCancel"
              >
                <img alt="身份反面" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </div>
        </div>

        <!-- 分割线 -->
        <div class="vertical-divider"></div>

        <div class="right-section">
          <div class="personal-info">
            <div class="info-item">
              <span class="label">姓名：</span>
              <span>{{ front.certName }}</span>
            </div>
            <div class="info-item">
              <span class="label">身份证号：</span>
              <span>{{ front.certNum }}</span>
            </div>
            <div class="info-item">
              <span class="label">性别：</span>
              <span>{{ front.sex }}</span>
            </div>
            <div class="info-item">
              <span class="label">出生日期：</span>
              <span>{{ front.birthday }}</span>
            </div>
            <div class="info-item">
              <span class="label">民族：</span>
              <span>{{ front.nationality }}</span>
            </div>
            <div class="info-item">
              <span class="label">住址：</span>
              <span>{{ front.certAddress }}</span>
            </div>

            <div class="info-item">
              <span class="label">身份证有效期：</span>
              <span>{{ back.certEfffromDate }}-{{ back.certEffToDate }}</span>
            </div>
          </div>
          <div class="error-msg" style="margin-top: 15px">
            <span
              >通过身份证自动获取身份信息，请检查身份证信息是否正确，如有错误，请重新上传图片。</span
            >
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <a-button
          @click="CertnextStep"
          type="primary"
          size="large"
          :loading="state.loginBtn"
          >下一步</a-button
        >
      </div>
    </div>

    <!-- 第二部分：二维码验证 -->
    <div v-if="currentStep === 1">
      <div class="step-2">
        <div class="qr-section">
          <p class="qr-text">
            请用微信扫描下方二维码，完成身份验证，身份验证通过后即可进行下一步
          </p>
          <div class="qr-code">
            <img
              :src="qrCodeFaceId"
              alt="QR Code"
              style="width: 150px; height: 150px"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-if="currentStep === 2">
      <a-result
        status="success"
        title="人脸核身成功"
        sub-title="您的身份信息已通过系统校验，并完成身份认证，请点击下方【返回】按钮，返回业务页面继续后续操作"
      >
        <template #extra>
          <a-button @click="changeToInfoDetail"> 返回 </a-button>
        </template>
      </a-result>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import storage from "store";
import { creatTencentFaceId } from "@/api/user/personalCenter/PersonalCenter.js";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { baseUrl } from "../../../../../../env";
export default {
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },

  watch: {
    currentStep(newVal, oldVal) {
      if (newVal === 1 && oldVal === 0) {
        console.log("[WS] step=1，建立连接");
        this.connectFaceIdWebSocket(this.websocketUid);
      } else {
        console.log("[WS] 离开 step=1，关闭连接");
        this.closeWebSocket();
      }
    },
  },

  data() {
    return {
      currentStep: 0, // 当前步骤
      idCardFront: [],
      idCardBack: [],
      previewVisible: false,
      previewImage: "",

      qrCodeFaceId: "",
      websocket: null,
      websocketUid: "",
      websocketTicket: "",
      wsConnected: false,
      wsState: "CLOSED",
      wsHeartbeatTimer: null,
      wsAuthTimer: null,
      wsReconnectTimer: null,
      wsLastPongAt: 0,
      wsReconnectAttempts: 0,
      wsFirstReconnectAt: 0,
      wsReconnectNoticeShown: false,
      wsManualClose: true,
      wsAuthenticated: false,
      wsAuthSent: false,
      handledMessageIds: {},

      front: {
        certName: "",
        certNum: "",
        sex: "",
        birthday: "",
        nationality: "",
        certAddress: "",
      },

      back: {
        certEfffromDate: "",
        certEffToDate: "",
      },
      state: {
        loginBtn: false,
      },
    };
  },
  mounted() {},
  beforeDestroy() {
    this.closeWebSocket(true);
  },
  methods: {
    connectFaceIdWebSocket(uid) {
      if (!uid || !this.websocketTicket || this.currentStep !== 1) return;
      if (
        this.websocket &&
        (this.websocket.readyState === WebSocket.OPEN ||
          this.websocket.readyState === WebSocket.CONNECTING)
      ) {
        return;
      }

      this.clearReconnectTimer();
      this.clearAuthTimer();
      this.wsManualClose = false;
      this.wsAuthenticated = false;
      this.wsAuthSent = false;
      this.wsState = this.wsReconnectAttempts > 0 ? "RECONNECTING" : "CONNECTING";
      let socket;
      try {
        socket = new WebSocket(this.buildFaceIdWebSocketUrl(uid));
      } catch (error) {
        console.error("[WS] 创建连接失败", { uid, error });
        this.scheduleWebSocketReconnect();
        return;
      }
      this.websocket = socket;

      socket.onopen = () => {
        if (this.websocket !== socket) return;
        this.wsState = "AUTHENTICATING";
        console.log("[WS] 握手成功，发送Ticket鉴权", { uid });
        this.authenticateWebSocket(socket);
        this.startAuthTimer(socket);
      };

      socket.onmessage = (event) => {
        if (this.websocket !== socket) return;
        this.handleFaceIdMessage(event.data, socket);
      };

      socket.onerror = (err) => {
        if (this.websocket !== socket) return;
        console.error("[WS] 连接异常，uid =", uid, err);
      };

      socket.onclose = (event) => {
        if (this.websocket !== socket) return;
        const previousState = this.wsState;
        const shouldReconnect = !this.wsManualClose && this.currentStep === 1;
        console.log("[WS] 连接关闭", {
          uid,
          code: event.code,
          reason: event.reason,
          state: previousState,
          clean: event.wasClean,
        });
        this.websocket = null;
        this.wsConnected = false;
        this.wsAuthenticated = false;
        this.wsState = "CLOSED";
        this.stopHeartbeat();
        this.clearAuthTimer();
        if (event.code === 1008) {
          this.wsManualClose = true;
          this.$notification.error({
            message: "核身连接已失效",
            description: "核身任务凭证已失效，请返回后重新发起核身",
          });
          this.websocketTicket = "";
          this.currentStep = 0;
          return;
        }
        if (shouldReconnect) {
          this.scheduleWebSocketReconnect();
        }
      };
    },

    buildFaceIdWebSocketUrl(uid) {
      const apiUrl = new URL(baseUrl, window.location.origin);
      apiUrl.protocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
      return `${apiUrl.origin}/common-websocket/tencentFaceIdServer/${encodeURIComponent(
        uid
      )}`;
    },

    authenticateWebSocket(socket) {
      if (
        !socket ||
        socket !== this.websocket ||
        socket.readyState !== WebSocket.OPEN ||
        !this.websocketTicket ||
        this.wsAuthSent
      ) {
        return;
      }
      try {
        socket.send(
          JSON.stringify({
            type: "AUTH",
            ticket: this.websocketTicket,
          })
        );
        this.wsAuthSent = true;
      } catch (error) {
        this.wsAuthSent = false;
        console.error("[WS] Ticket鉴权消息发送失败", error);
        socket.close(4001, "authentication request failed");
      }
    },

    startAuthTimer(socket) {
      this.clearAuthTimer();
      this.wsAuthTimer = setTimeout(() => {
        if (
          this.websocket === socket &&
          socket.readyState === WebSocket.OPEN &&
          !this.wsAuthenticated
        ) {
          console.warn("[WS] Ticket鉴权响应超时，重建连接", {
            uid: this.websocketUid,
          });
          socket.close(4001, "authentication response timeout");
        }
      }, 12000);
    },

    clearAuthTimer() {
      if (this.wsAuthTimer) {
        clearTimeout(this.wsAuthTimer);
        this.wsAuthTimer = null;
      }
    },

    startHeartbeat() {
      this.stopHeartbeat();
      this.wsLastPongAt = Date.now();
      this.wsHeartbeatTimer = setInterval(() => {
        if (
          this.websocket &&
          this.websocket.readyState === WebSocket.OPEN &&
          this.wsAuthenticated
        ) {
          if (Date.now() - this.wsLastPongAt > 45000) {
            console.warn("[WS] 心跳超时，主动重建连接，uid =", this.websocketUid);
            this.websocket.close(4000, "heartbeat timeout");
            return;
          }
          this.websocket.send("PING");
        }
      }, 15000);
    },

    stopHeartbeat() {
      if (this.wsHeartbeatTimer) {
        clearInterval(this.wsHeartbeatTimer);
        this.wsHeartbeatTimer = null;
      }
    },

    scheduleWebSocketReconnect() {
      if (
        this.wsReconnectTimer ||
        this.currentStep !== 1 ||
        !this.websocketUid ||
        !this.websocketTicket
      ) {
        return;
      }
      this.wsReconnectAttempts += 1;
      if (!this.wsFirstReconnectAt) {
        this.wsFirstReconnectAt = Date.now();
      }
      const baseDelay = Math.min(
        1000 * Math.pow(2, Math.min(this.wsReconnectAttempts - 1, 4)),
        15000
      );
      const delay = baseDelay + Math.floor(Math.random() * 500);
      this.wsState = "RECONNECTING";
      // 短暂的一两次重连不打扰用户；连续异常超过15秒再提示。
      if (
        Date.now() - this.wsFirstReconnectAt >= 15000 &&
        !this.wsReconnectNoticeShown
      ) {
        this.wsReconnectNoticeShown = true;
        this.$notification.warning({
          message: "核身连接不稳定",
          description: "系统正在自动重新连接，请保持当前页面打开",
        });
      }
      console.log("[WS] 安排重连", {
        uid: this.websocketUid,
        attempt: this.wsReconnectAttempts,
        delay,
      });
      this.wsReconnectTimer = setTimeout(() => {
        this.wsReconnectTimer = null;
        this.connectFaceIdWebSocket(this.websocketUid);
      }, delay);
    },

    clearReconnectTimer() {
      if (this.wsReconnectTimer) {
        clearTimeout(this.wsReconnectTimer);
        this.wsReconnectTimer = null;
      }
    },

    handleFaceIdMessage(message, socket = this.websocket) {
      let payload = null;
      if (typeof message === "string" && message.startsWith("{")) {
        try {
          payload = JSON.parse(message);
        } catch (error) {
          console.warn("[WS] JSON消息解析失败", error);
        }
      }

      if (payload) {
        console.log("[WS] 收到消息", {
          type: payload.type,
          uid: payload.uid,
          messageId: payload.messageId || payload.value,
        });
        if (payload.uid && payload.uid !== this.websocketUid) {
          console.warn("[WS] 忽略UID不匹配的消息", {
            expectedUid: this.websocketUid,
            actualUid: payload.uid,
            type: payload.type,
          });
          return;
        }
        if (payload.type === "AUTH_REQUIRED") {
          if (!this.wsAuthenticated && !this.wsAuthSent) {
            this.authenticateWebSocket(socket);
          }
          return;
        }
        if (payload.type === "WS_AUTHENTICATED") {
          this.clearAuthTimer();
          this.wsAuthenticated = true;
          this.wsConnected = true;
          this.wsState = "CONNECTED";
          this.wsReconnectAttempts = 0;
          this.wsFirstReconnectAt = 0;
          this.wsReconnectNoticeShown = false;
          this.startHeartbeat();
          return;
        }
        if (payload.type === "PONG") {
          this.wsLastPongAt = Date.now();
          return;
        }
        if (payload.type === "ACK_CONFIRMED") {
          return;
        }
        if (payload.type === "FACE_ID_RESULT") {
          this.handleStructuredFaceIdResult(payload, socket);
          return;
        }
        // 灰度发布期间兼容旧服务端；新版服务端不会再发送 WS_CONNECTED。
        if (payload.type === "WS_CONNECTED") {
          this.clearAuthTimer();
          this.wsAuthenticated = true;
          this.wsConnected = true;
          this.wsState = "CONNECTED";
          this.wsReconnectAttempts = 0;
          this.wsFirstReconnectAt = 0;
          this.startHeartbeat();
          return;
        }
      }

      // 1️⃣ 业务成功信号（后端约定）
      if (message === "核身完成") {
        setTimeout(() => {
          this.$notification.success({
            message: "核身成功",
            description: "身份核验已通过",
          });
        }, 300);

        this.closeWebSocket();
        this.currentStep++;
        return;
      }

      // 主平台个人认证或授权失败，展示主平台返回的错误信息
      const failurePrefix = "核身失败：";
      if (typeof message === "string" && message.startsWith(failurePrefix)) {
        const description = message.substring(failurePrefix.length) || "身份认证失败，请重新核身";
        this.$notification.error({
          message: "核身失败",
          description,
          duration: 4,
        });
        this.closeWebSocket();
        this.currentStep = 0;
        return;
      }

      // 2️⃣ 心跳 / 连接类消息 —— 直接忽略
      if (
        typeof message === "string" &&
        (message.toLowerCase() === "pong" || message.toLowerCase() === "ping")
      ) {
        this.wsLastPongAt = Date.now();
        return;
      }

      // 3️⃣ 其他 JSON 控制消息（如 WS_CONNECTED）
      if (typeof message === "string" && message.startsWith("{")) {
        try {
          const data = JSON.parse(message);
          console.log("[WS] 控制消息：", data);
          return;
        } catch (e) {
          // 不是合法 JSON，直接忽略
          return;
        }
      }

      // 4️⃣ 未知消息兜底（不关闭连接）
      console.warn("[WS] 未处理的 WS 消息：", message);
    },

    handleStructuredFaceIdResult(payload, socket) {
      const messageId = payload.messageId;
      const message = payload.message || "";
      if (!messageId) {
        console.warn("[WS] 核身结果缺少messageId", payload);
        return;
      }
      if (this.handledMessageIds[messageId]) {
        this.sendFaceIdAck(socket, messageId);
        return;
      }

      const isSuccess = message === "核身完成";
      const failurePrefix = "核身失败：";
      if (!isSuccess && !message.startsWith(failurePrefix)) {
        console.warn("[WS] 未识别的核身结果", { messageId, message });
        return;
      }

      this.$set(this.handledMessageIds, messageId, true);
      if (isSuccess) {
        this.$notification.success({
          message: "核身成功",
          description: "身份核验已通过",
        });
      } else {
        this.$notification.error({
          message: "核身失败",
          description:
            message.substring(failurePrefix.length) || "身份认证失败，请重新核身",
          duration: 4,
        });
      }

      this.sendFaceIdAck(socket, messageId);
      this.wsManualClose = true;
      // 先让 ACK 进入 WebSocket 发送队列，再由步骤切换触发主动关闭。
      setTimeout(() => {
        if (isSuccess) {
          this.currentStep += 1;
        } else {
          this.currentStep = 0;
        }
      }, 100);
    },

    sendFaceIdAck(socket, messageId) {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: "ACK", messageId }));
        console.log("[WS] 已发送ACK", {
          uid: this.websocketUid,
          messageId,
        });
      }
    },

    closeWebSocket(manual = true) {
      this.wsManualClose = manual;
      this.stopHeartbeat();
      this.clearAuthTimer();
      this.clearReconnectTimer();
      if (this.websocket) {
        const socket = this.websocket;
        this.websocket = null;
        socket.close(1000, manual ? "client close" : "reconnect");
      }
      this.wsConnected = false;
      this.wsAuthenticated = false;
      this.wsAuthSent = false;
      this.wsState = "CLOSED";
    },

    changeToInfoDetail() {
      this.closeWebSocket();
      this.$emit("changeToInfoDetail");
    },

    //预览
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    //身份证正面照图片变更
    handleIdCardFrontChange({ fileList }) {
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            this.front.certName = item.response.data.idCardFrontData.certName;
            this.front.certNum = item.response.data.idCardFrontData.certNum;
            this.front.sex = item.response.data.idCardFrontData.sex;
            this.front.birthday = item.response.data.idCardFrontData.birthday;
            this.front.certAddress =
              item.response.data.idCardFrontData.certAddress;
            this.front.nationality =
              item.response.data.idCardFrontData.nationality;
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data.idCardFrontOssUrl,
            };
          }
          if (item.response.code == "400") {
            setTimeout(() => {
              this.$notification["error"]({
                message: "错误",
                description: (item.response || {}).data || {},
                duration: 4,
              });
            }, 300);

            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.idCardFront = fileList;
    },

    //身份证反面照图片变更
    handleIdCardBackChange({ fileList }) {
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            this.back.certEfffromDate =
              item.response.data.idCardBackData.certEfffromDate;
            this.back.certEffToDate =
              item.response.data.idCardBackData.certEffToDate;
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data.idCardBackOssUrl,
            };
          }
          if (item.response.code == "400") {
            setTimeout(() => {
              this.$notification["error"]({
                message: "错误",
                description: (item.response || {}).data || {},
                duration: 4,
              });
            }, 300);
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.idCardBack = fileList;
    },

    previewHandleCancel() {
      this.previewVisible = false;
    },

    CertnextStep() {
      if (
        this.idCardFront.length > 0 &&
        this.idCardFront.every((f) => f.status === "done") &&
        this.idCardBack.length > 0 &&
        this.idCardBack.every((f) => f.status === "done")
      ) {
        this.state.loginBtn = true;
        creatTencentFaceId({
          ruleId: "4",
          idCard: this.front.certNum,
          name: this.front.certName,
        })
          .then((res) => {
            if (res && res.code === "200") {
              const result = res.data;
              QRCode.toDataURL(result.url).then((res) => {
                this.qrCodeFaceId = res;
              });
              this.websocketUid = result.uid;
              this.websocketTicket = result.wsTicket;
              this.handledMessageIds = {};
              this.wsReconnectAttempts = 0;
              this.wsFirstReconnectAt = 0;
              this.wsReconnectNoticeShown = false;
              this.state.loginBtn = false;
              this.currentStep++;
            } else {
              this.$notification.error({
                message: "错误",
                description: (res && res.msg) || "发起核身失败，请稍后重试",
                duration: 4,
              });
              this.state.loginBtn = false;
            }
          })
          .catch((err) => {
            console.error("接口调用异常：", err);
            this.state.loginBtn = false;
            this.$notification.error({
              message: "错误",
              description: "发起核身失败，请稍后重试",
            });
          });
      } else {
        setTimeout(() => {
          this.$notification["error"]({
            message: "错误",
            description: "请按要求上传身份证正反面",
            duration: 4,
          });
        }, 300);
      }
    },

    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
  },
};
</script>

<style scoped>
.identity-verification {
  padding: 20px;
}

.verification-content {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.qr-section {
  text-align: center;
}

.left-section {
  width: 48%;
}
.right-section {
  width: 48%;
}

.vertical-divider {
  width: 1px;
  background-color: #e8e8e8;
  margin: 0 20px;
}

.upload-item {
  margin-bottom: 20px;
}

.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 24px;
  color: #1890ff;
  margin-right: 10px;
}

.upload-btn {
  margin-top: 10px;
}

.personal-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
}

.info-item {
  display: flex;
  margin-bottom: 24px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

.error-msg {
  color: red;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
